import styled from '@emotion/styled';
import {
	css_background,
	css_fill,
	css_gap,
	css_xlarge,
	css_letter,
	css_medium_up,
	css_quick,
	css_stroke,
	css_text,
	css_if,
} from '~/emotion/theme';
import BetaAgentList, { BetaAgentCard } from '~/editor/templates/beta/lib/BetaAgentList';
import BetaSectionHeader from '~/editor/templates/beta/lib/BetaSectionHeader';
import MicrositeSection from '~/components/MicrositeSection';
import type { ContactBlockVariant } from '~/editor/blocks/contact/common';

const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: ${css_gap('large')};
	flex: 1;
	background: ${css_background()};
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
	padding: ${css_gap('content')};
`;

const Row = styled.div`
	display: grid;
	gap: ${css_gap('large')};

	@media (${css_medium_up}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`;

const baseField = `
	width: 100%;
	border: none;
	border-bottom: 1px solid ${css_stroke()};
	background: transparent;
	padding: ${css_gap('grid', 2)} 0;
	color: ${css_text()};
	text-transform: uppercase;
	letter-spacing: ${css_letter('md')};
	font-size: 0.75rem;
	outline: none;
	transition: border-color ${css_quick};

	&::placeholder {
		color: ${css_text('weak')};
	}

	&:focus {
		border-bottom-color: ${css_text()};
	}
`;

const Input = styled.input`
	${baseField}
`;

const Textarea = styled.textarea`
	${baseField}
	min-height: 6rem;
	resize: vertical;
`;

const Submit = styled.button`
	align-self: flex-start;
	border: none;
	background: ${css_fill()};
	padding: ${css_gap('grid', 1.5)} ${css_gap('large')};
	color: ${css_text()};
	text-transform: uppercase;
	letter-spacing: ${css_letter('md')};
	font-size: 0.625rem;
	font-weight: 700;
	transition:
		background ${css_quick},
		color ${css_quick};

	&:hover {
		background: ${css_text()};
		color: ${css_background()};
	}
`;

const Combined = styled.div<{ single: boolean }>`
	display: flex;
	flex-direction: column;
	gap: ${css_gap('grid')};

	@media (${css_medium_up}) {
		flex-direction: ${css_if('single', 'row', 'column')};
	}

	@media (${css_xlarge}) {
		flex-direction: row;
	}
`;

export default function ContactBlockBeta({ id, title, profiles }: ContactBlockVariant) {
	const single = profiles.length === 1;

	return (
		<MicrositeSection id={id} padding fill>
			{title && <BetaSectionHeader align="end" title={title} titleFirst />}
			<Combined single={single}>
				{single ? <BetaAgentCard single={true} profile={profiles[0]} /> : <BetaAgentList profiles={profiles} />}
				<Form>
					<Row>
						<Input type="text" placeholder="First*" />
						<Input type="text" placeholder="Last*" />
					</Row>
					<Input type="email" placeholder="Email*" />
					<Input type="tel" placeholder="Phone #" />
					<Textarea placeholder="Message" />
					<Submit type="button">Send Inquiry</Submit>
				</Form>
			</Combined>
		</MicrositeSection>
	);
}
